module.exports = __webpack_public_path__ + "img/z (8).0fa46e2e.png";